import axios from "axios";
import QS from "qs";
import moment from "moment";
import xlooLib from "../../../librarys/xlooLib";

export default {
    SET_searchDonationLocation: async (context) => {
        let urlDonorPortal = context.rootGetters['settingsAndCustomize/configurationSite'].urlSite;
        const dataRequest= {
            entryPoint: 'appointment_calendar',
            entryAction: 'bookingDay',
            action: 'entryPoints',
            dateFrom: moment(context.getters.dataRequestDonationLocation.dateFrom, "MM/DD/YYYY").format('YYYY-MM-DD'),
            dateTo: moment(context.getters.dataRequestDonationLocation.dateTo, "MM/DD/YYYY").format('YYYY-MM-DD'),
            type: '',
            eligibility: context.getters.dataRequestDonationLocation.eligibility,
            lat: context.getters.dataRequestDonationLocation.lat,
            lng: context.getters.dataRequestDonationLocation.lng,
            dist: 1609.4 * context.getters.dataRequestDonationLocation.dist,
            donorId: context.rootGetters['donorInformation/idDonor'],
            siteType: context.getters.dataRequestDonationLocation.siteType,
        }
        const  urlRequestApi = urlDonorPortal + 'api'

        const res_donationLocation = await xlooLib.ajaxCheckSession(urlRequestApi, dataRequest)
        context.commit('set_dataDonationLocation', { responseData: res_donationLocation.data.result.sites.data, })
        context.commit('set_showPage',{ triggerDonationLocation: true })
        return res_donationLocation.data.result.sites.data

    },
    SET_createBookingTab: async (context, payload) =>{
        let urlDonorPortal = context.rootGetters['settingsAndCustomize/configurationSite'].urlSite + 'api';
        const dataCreateBookingTab = {
            action: 'entryPoints',
            entryPoint: 'appointment_calendar',
            entryAction: 'bookingForm',
            profileId: context.getters.dataDonationLocation.profileId,
            profileCode: context.getters.dataBookingAppointment.mobileCode,
            donorId: context.rootGetters['donorInformation/idDonor'],
            type: '',
            eligibility: context.getters.dataRequestDonationLocation.eligibility,
            apptId: '',
        };
        if(payload.entryPoint !== 'manege'){
            dataCreateBookingTab.moduleApptId = context.getters.dataBookingAppointment.apptId
        }

        const res_createBookingTab = await xlooLib.ajaxCheckSession(urlDonorPortal, dataCreateBookingTab)
        if (res_createBookingTab?.data?.data === 'Incorrect Profile Code'){
            return {error: true, message: res_createBookingTab.data.data}
        }

        context.commit('set_createBookingTab', { responseData: res_createBookingTab.data.result.form})
        context.commit('set_showPage',{ triggerBookingAppointment: true })
        //записать результат в сторе, обрабатывать уже в новой странице
        return res_createBookingTab.data.result.form
    },
    SET_checkEmailOldDonor: async(context, payload) => {
        let dataRequest = {
            action: 'entryPoints',
            entryPoint: 'appointment_calendar',
            entryAction: 'bookingInfo',
            donorEmail: payload,
        }
        let urlRequest = context.rootGetters['settingsAndCustomize/configurationSite'].urlSite + 'api';
        try {
            // eslint-disable-next-line no-unused-vars
            const resCheckEmailOldDonor = await axios.post(urlRequest, QS.stringify(dataRequest))
            if (typeof resCheckEmailOldDonor['Fatal error'] === 'undefined') {
                if (!resCheckEmailOldDonor.data.result.donorIsNew) {
                    context.commit('donorInformation/set_newDonor', false, {root: true})
                    context.commit('donorInformation/set_email', payload, {root: true})
                    let dataRequest = {
                        action: 'oldDonorProcessing',
                        id: context.rootGetters["donorInformation/idDonor"],
                        primary_address_street: 'old',
                    }
                    const urlRequest = context.rootGetters['settingsAndCustomize/configurationSite'].urlSite + 'api';

                    // eslint-disable-next-line no-unused-vars
                    const resOldDonor = await axios.post(urlRequest, QS.stringify(dataRequest))
                    return { newDonor: false }
                } else {
                    return { newDonor: true }
                }
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_bookingRequest: async ( context, payload ) => {
        let urlRequest = context.rootGetters['settingsAndCustomize/configurationSite'].urlSite + 'api';

        const  resBookingRequest = await xlooLib.ajaxCheckSession(urlRequest, payload)

        return resBookingRequest.data.result
    },
    SET_registrationTemporaryDonor: async ( context, payload ) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        try {
            const response = await axios.post(urlRequest, QS.stringify(payload))

            if(
                (response?.data?.result === 'donor reassign' || response?.data?.result === 'new donor create')
                && response?.data?.data_donor
            ){
                context.commit('donorInformation/set_idDonor', response.data.data_donor?.id, {root: true})
                context.commit('donorInformation/set_phoneMobile', response.data.data_donor?.phone_mobile, {root: true})
                context.commit('donorInformation/set_smsOptedOut', response.data.data_donor?.sms_opted_out, {root: true})
            }

            return response
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_confirm: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        return await xlooLib.ajaxCheckSession(urlRequest, payload)
    },
    SET_changeTimeAppointment: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        try {
            const resConfirm = await xlooLib.ajaxCheckSession(urlRequest, payload);
            return resConfirm
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getUrlRouting: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        let params = {
            action: 'entryPoints',
            entryPoint: 'appointment_calendar',
            entryAction: 'bookingGeo',
            OSRM_DIRS: 'Y',
        }

        return await xlooLib.ajaxCheckSession(urlRequest, params)
    },
    SET_cancelingDonorAppointment: async (context, payload)=>{
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataDelete = {
            action: 'entryPoints',
            entryPoint: 'appointment_calendar',
            entryAction: 'deleteAppointment',
            apptIdCal: payload,
            mode: 'cancel',
        }

        const response = await xlooLib.ajaxCheckSession(urlRequest, dataDelete)
        if (typeof response?.data?.result !== 'undefined'){
            return response
        } else {
            return false
        }

    },
    SET_cancelingTemporaryDonorAppointment: async (context, payload)=>{
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataDelete = {
            action: 'entryPoints',
            entryPoint: 'appointment_calendar',
            entryAction: 'deleteAppointment',
            apptId: payload,
            mode: 'delete-real',
        }

        await axios.post(urlRequest, QS.stringify(dataDelete))

    },
    SET_rescheduleAppointment:  async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        let dataRequest = {
            action: 'rescheduleAppointment',
            moduleApptId: payload.idApp,
            donorId: context.rootGetters["donorInformation/idDonor"],

            dateFrom: moment().format('YYYY-MM-DD'),
            dateTo: moment().add(1, 'M').format('YYYY-MM-DD'),
            type: '',
            eligibility: context.rootGetters["donateBloodAppointments/dataRequestDonationLocation"].eligibility,
            lat: typeof payload.coordinates.lat !== 'undefined'?payload.coordinates.lat:'',
            lng: typeof payload.coordinates.lng !== 'undefined'?payload.coordinates.lng:'',
            dist: context.rootGetters["settingsAndCustomize/siteCustomizationData"].appointmentsPage.distanceOptions.distance,
            siteType: 'all',
        };
        if (payload.typeProcedure){
            dataRequest.typeProcedure = payload.typeProcedure
        }
        if (payload.idProfile){
            dataRequest.idProfile = payload.idProfile
        }

        const res_rescheduleAppointment = await xlooLib.ajaxCheckSession(urlRequest, dataRequest)

        const   idProfile = typeof res_rescheduleAppointment.data.result.profile_id !=='undefined'?res_rescheduleAppointment.data.result.profile_id:'',
                typeProcedure = typeof res_rescheduleAppointment.data.result.type_procedure !=='undefined'?res_rescheduleAppointment.data.result.type_procedure:'',
                donationLocation = typeof res_rescheduleAppointment.data.result.donation_location !=='undefined'?res_rescheduleAppointment.data.result.donation_location:''

        context.commit('set_actionVariableDonateBlood', {varReschedule: {idApp: payload.idApp, idProfile: idProfile, typeProcedure: typeProcedure} })
        context.commit('set_dataDonationLocation', { responseData: donationLocation, })
        context.commit('set_showPage',{ triggerDonationLocation: true })
    }
}
